'use strict';
/**
 * @author Maxim Seredkin
 */
import angular from "angular";


export default ['$scope', '$uibModalInstance', 'org', 'orgFilters',
    function ($scope, $modalInstance, org, orgFilters) {

        $scope.ok = ok;
        $scope.cancel = cancel;
        $scope.isSelect = isSelect;

        // инициализация
        init();

        // region Function

        function init() {
            $scope.org = angular.copy(org);
            $scope.filters = angular.copy(orgFilters);
        }

        function ok(org) {
            $modalInstance.close(org);
        }

        function cancel() {
            $modalInstance.dismiss();
        }

        function isSelect() {
            return $scope.org != null && $scope.org.id != null;
        }

        // endregion

    }]